<template>
  <div>
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="800px"
    center
    destroy-on-close
    >
    <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="150px">
      <el-form-item label="公司名称：">
        {{ row.company_name }}
      </el-form-item>
      <el-form-item label="统一信用代码：">
        {{ row.credit_code }}
      </el-form-item>
      <el-form-item label="营业执照：">
        <el-image v-if="row.license" @click="imgUrl=row.license;dialogVisible1=true"
          style="width: 240px; height: 120px;cursor: pointer;"
          :src="row.license + '?imageMogr2/thumbnail/240x'"
          fit="cover"></el-image>
      </el-form-item>
      <el-form-item label="管理者名称：">
        {{ row.name }}
      </el-form-item>
      <el-form-item label="管理者手机号码：">
        {{ row.phone }}
      </el-form-item>
      <el-form-item label="管理者身份证号码：">
        {{ row.identity_card }}
      </el-form-item>
      <tempalte v-if="row.audit_status == 0 || row.audit_status == 10">
        <el-form-item label="状 态：" prop="audit_status">
          <el-radio-group v-model="formData.audit_status">
            <el-radio :label="10">审核中</el-radio>
            <el-radio :label="20">已通过</el-radio>
            <el-radio :label="30">未通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="未通过原因：" prop="reject_reason" v-if="formData.audit_status == 30">
          <el-input type="textarea" @input="
          formData.reject_reason=formData.reject_reason<120?formData.reject_reason: formData.reject_reason.slice(0,120)" 
          style="width: 400px;" rows="4" :maxlength="120" show-word-limit
          v-model="formData.reject_reason" placeholder="请输入未通过原因"></el-input>
        </el-form-item>
      </tempalte>
      <template v-else>
        <el-form-item label="状 态：" prop="audit_status">
          <el-tag type="success" v-if="row.audit_status == 20">已通过</el-tag>
          <el-tag type="danger" v-if="row.audit_status == 30">未通过</el-tag>
        </el-form-item>
        <el-form-item label="未通过原因：" prop="reject_reason" v-if="row.audit_status == 30">
          <el-input type="textarea" style="width: 400px;" rows="4" :maxlength="120" show-word-limit disabled
          v-model="row.reject_reason" placeholder="请输入未通过原因"></el-input>
        </el-form-item>
      </template>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button @click="save" type="primary" v-if="row.audit_status == 0 || row.audit_status == 10">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="查看图片"
    :visible.sync="dialogVisible1"
    width="40%"
    center
    >
    <img :src="imgUrl" alt="" style="display: block;width: 100%;">
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible1 = false">取 消</el-button>
    </span>
  </el-dialog>
  </div>
  
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        title: '',
        formData: { //弹窗 内容
          audit_status: 10,
          reject_reason: ''
        },
        types: [
          {label: '社工服务', value: 'community'},
          {label: '志愿风采', value: 'volunteer'}
        ],
        row: '',
        rules: {
          audit_status: [{
            required: true,
            message: '请选择状态',  
            trigger: 'change'
          }],
          reject_reason: [{
            required: true,
            message: '请输入未通过原因',  
            trigger: 'blur'
          }]
        },
        imgUrl: '',
        dialogVisible1: false
      }
    },
    methods: {
      show(row){
        if(row){
          this.title = '审核企业'
          this.row = row
          this.formData = {
            companyId: row.id,
            audit_status: 10,
            reject_reason: ''
          }
          this.dialogVisible = true
        }
      },
      save(formList){
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(this.formData.companyId){
              userInfoAPI.companyEdit(this.formData).then(({ data })=>{
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }
          }
        })
       
      },
      uploadError(err, file, fileList) {
        this.$message({
            message: "上传出错，请重试！",
            type: "error",
            center: true
          });
        },
      handleAvatarSuccess(file){
        const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
        const isLt5M = file.raw.size / 1024 / 1024 < 5
        if (!isIMAGE) {
          this.$message({
            showClose: true,
            message: '请选择 jpg、png 格式的图片',
            type: 'warning'
          })
          return false
        }
        if (!isLt5M) {
          this.$message({
            showClose: true,
            message: '图片大小不能超过 5MB',
            type: 'warning'
          })
          return false
        }
        upload([file.raw], 'activity').then((urls)=>{
          this.formData.thumb = urls[0]
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/{
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
  }
</style>